import {Component, Injector, Input} from '@angular/core';
import {PesMessageComponent} from '@pes/ui';

/**
 * The standard message page displayed at the end of a circuit.
 */
@Component({
    selector: 'pes-message',
    templateUrl: './pes-message.component.html',
    styleUrls: ['./pes-message.component.scss']
})
export class MessageComponent extends PesMessageComponent{

    @Input() public redirection: string = null;

    @Input() healthData: string;

    @Input() contractType: string;

    /**
     * Creates a new PesMessageComponent instance.
     *
     * @param {Injector} injector a reference to the Angular injector.
     */
    constructor(protected injector: Injector) {
        super(injector);
    }
}



// WEBPACK FOOTER //
// ./src/app/component/pes-message/pes-message.component.ts